import homeActionKeys from './homeActionKeys';
import { sendOfficeEvent } from '../../../app/common/eventService';
import { getCid } from '../../../app/browser/analyticsHelpers';
import homeServices from './homeServices';

export const markModalSeen = spid => ({
  type: homeActionKeys.MARK_MODAL_SEEN,
  payload: { spid },
});

export const sendHomePageVisitEvent = () => ({
  type: homeActionKeys.SEND_HOME_PAGE_VISIT_EVENT,
  payload: sendOfficeEvent({
    eventName: 'SP : Home',
    properties: {
      cid: getCid(),
    },
  }),
});

export const getAllHighlights = () => ({
  type: homeActionKeys.GET_ALL_HIGHLIGHTS,
  payload: homeServices.getAllHighlights(),
});

export const updateBusinessHighlights = (serviceProviderId, values) => ({
  type: homeActionKeys.UPDATE_BUSINESS_HIGHLIGHTS,
  payload: homeServices.updateBusinessHighlights(serviceProviderId, values),
});



// WEBPACK FOOTER //
// ./src/modules/home/common/homeActions.js